const STORAGE_KEY = 'tm-agenda:hidden-announcements';

const normalizeAnnouncementId = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const readDismissedAnnouncementIds = () => {
  if (typeof window === 'undefined') return [];

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const parsed = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];

    return parsed.map(normalizeAnnouncementId).filter(Boolean);
  } catch {
    return [];
  }
};

export const writeDismissedAnnouncementIds = (ids) => {
  if (typeof window === 'undefined') return;

  const nextIds = Array.from(new Set((Array.isArray(ids) ? ids : []).map(normalizeAnnouncementId).filter(Boolean)));

  if (nextIds.length === 0) {
    window.localStorage.removeItem(STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextIds));
};

export const dismissAnnouncementById = (announcementId) => {
  const normalizedId = normalizeAnnouncementId(announcementId);
  if (!normalizedId) return;

  const dismissedIds = new Set(readDismissedAnnouncementIds());
  dismissedIds.add(normalizedId);
  writeDismissedAnnouncementIds([...dismissedIds]);
};

export const restoreAnnouncementById = (announcementId) => {
  const normalizedId = normalizeAnnouncementId(announcementId);
  if (!normalizedId) return;

  const dismissedIds = new Set(readDismissedAnnouncementIds());
  if (!dismissedIds.delete(normalizedId)) return;

  writeDismissedAnnouncementIds([...dismissedIds]);
};
